<div class="container loginContainer">
  <div class="col-md-12">
    <!-- verify section -->
    <div *ngIf="false">
      <div
        class="card lgFrmCard login-verify-card"
        *ngIf="showVerifyForm === 'verify'"
      >
        <p class="text-center verify-heading">
          <b>Please confirm your email</b>
        </p>
        <p class="text-center">
          We've sent a verification PIN to your Email and Mobile
        </p>
        <div class="form-group">
          <label class="form-label mandatoryLabel"
            >Verification PIN <i class="fa-solid fa-asterisk mandatoryIcon"></i
          ></label>
          <div class="input-field">
            <input
              id="otp"
              name="otp"
              #verifyOTP
              [(ngModel)]="otpInput"
              [ngModelOptions]="{ standalone: true }"
              class="form-control"
              type="text"
              placeholder="Enter your PIN"
            />
          </div>
          <div class="text-danger" #verifyOTPError>Enter valid PIN</div>
        </div>
        <button
          class="btn btn-primary signInBtn"
          type="button"
          #verifyOTPBtn
          (click)="submitOtp()"
        >
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
            <span class="sr-only">Loading...</span>
          </i>
          Verify
        </button>
        <p class="ReturnLoginTxt text-center">
          <a class="returnClass" (click)="goBack()">Return to Log in</a>
        </p>
      </div>
    </div>
    <div
      class="card lgFrmCard login-verify-card"
      *ngIf="showVerifyForm === 'verify'"
    >
      <p class="text-center verify-heading"><b>Please confirm your email</b></p>
      <p class="text-center">
        We've sent a verification PIN to your Email and Mobile
      </p>

      <div class="form-group">
        <label class="form-label mandatoryLabel"
          >Verification PIN
          <i class="fa-solid fa-asterisk mandatoryIcon"></i>
        </label>
        <div class="input-field">
          <input
            id="otp"
            name="otp"
            #verifyOTP
            [(ngModel)]="otpInput"
            [ngModelOptions]="{ standalone: true }"
            class="form-control"
            type="text"
            placeholder="Enter your PIN"
          />
        </div>
        <div class="text-danger" #verifyOTPError>Enter valid PIN</div>
      </div>

      <!-- ── CAPTCHA BLOCK ───────────────────────────────────── -->
      <div class="form-group captcha-group">
        <label class="form-label">Verify you are human</label>

        <div class="captcha-row">
          <div class="captcha-canvas-wrap">
            <canvas id="captchaCanvas" width="180" height="44"></canvas>
          </div>
          <button
            type="button"
            class="captcha-refresh-btn"
            (click)="generateCaptcha()"
            title="Refresh"
            aria-label="Refresh CAPTCHA"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>

        <div class="input-field">
          <input
            class="form-control"
            type="text"
            maxlength="6"
            placeholder="Case-sensitive, enter exactly as shown"
            [(ngModel)]="captchaInput"
            [ngModelOptions]="{ standalone: true }"
            (input)="verifyCaptcha()"
            autocomplete="off"
          />
        </div>

        <span class="text-danger" *ngIf="captchaSubmitted && !captchaVerified">
          Incorrect characters. Please try again.
        </span>
      </div>
      <!-- ──────────────────────────────────────────────────────── -->

      <button
        class="btn btn-primary signInBtn"
        type="button"
        #verifyOTPBtn
        (click)="submitOtp()"
      >
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
          <span class="sr-only">Loading...</span>
        </i>
        Verify
      </button>

      <p class="ReturnLoginTxt text-center">
        <a class="returnClass" (click)="goBack()">Return to Log in</a>
      </p>
    </div>
    <!-- otp form section -->
    <form [formGroup]="passwordForm" *ngIf="showVerifyForm === 'otp'">
      <div class="card lgFrmCard login-verify-card">
        <p class="text-center verify-heading">
          <b>{{ password_reset ? "Create Password" : "Reset Password" }}</b>
        </p>
        <div class="form-group">
          <label
            class="form-label mandatoryLabel"
            [ngClass]="{ 'is-invalid': submitted && f['password'].errors }"
            >New Password<i class="fa-solid fa-asterisk mandatoryIcon"></i
          ></label>
          <div class="input-field">
            <input
              class="form-control"
              [type]="type"
              formControlName="password"
              id="password"
              name="password"
            />
            <span
              class="fa {{ eyeIcon }} passwordEye"
              (click)="hideShowPassword()"
            ></span>
          </div>
          <div
            *ngIf="submitted && f['password'].errors"
            class="invalid-feedback text-danger"
          >
            <div class="text-danger" *ngIf="f['password'].errors['required']">
              New Password is required
            </div>
            <div class="text-danger" *ngIf="f['password'].errors['minlength']">
              Password must be at least 8 characters
            </div>
            <div class="text-danger" *ngIf="f['password'].errors['pattern']">
              Password must be at least 8 characters, and include at least 1
              number and 1 special character( _, &#64;, or $).
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label mandatoryLabel"
            >Confirm Password<i class="fa-solid fa-asterisk mandatoryIcon"></i
          ></label>
          <input
            type="password"
            formControlName="confirmPassword"
            class="form-control"
            [ngClass]="{
              'is-invalid': submitted && f['confirmPassword'].errors,
            }"
          />
          <div
            *ngIf="submitted && f['confirmPassword'].errors"
            class="invalid-feedback text-danger"
          >
            <div
              class="text-danger"
              *ngIf="f['confirmPassword'].errors['required']"
            >
              Confirm Password is required
            </div>
            <div
              class="text-danger"
              *ngIf="f['confirmPassword'].errors['matching']"
            >
              Confirm Password doesn't match.Please re-enter your password.
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary signInBtn"
          type="button"
          (click)="onSubmit()"
        >
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
            <span class="sr-only">Loading...</span>
          </i>
          {{ password_reset ? "Create Password" : "Reset Password" }}
        </button>
        <p class="ReturnLoginTxt text-center">
          <a class="returnClass" (click)="goBack()">Back to Log in</a>
        </p>
      </div>
    </form>
    <!-- password updated success fully -->
    <div
      class="card lgFrmCard login-verify-card"
      *ngIf="showVerifyForm === 'passwordSuccess'"
    >
      <p class="text-center verify-heading">
        <b>Password Created SuccessFully</b>
      </p>
      <div class="col-md-3 offset-md-4">
        <button
          class="btn btn-primary signInBtn passwordSuccessBtn"
          type="button"
          (click)="goBack()"
        >
          Return to Login
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="col-md-5 offset-md-1">

    </div> -->
</div>
